export const NAME = 'schoolManage';

const SET_STUDENTS_FILTERS = `SET_STUDENTS_FILTERS_${NAME}`;
const SET_STAFF_FILTERS = `SET_STAFF_FILTERS_${NAME}`;

export const setStudentsFilters = (campusId, filters) => ({
	type: SET_STUDENTS_FILTERS,
	payload: { campusId, filters },
});

export const setStaffFilters = (campusId, filters) => ({
	type: SET_STAFF_FILTERS,
	payload: { campusId, filters },
});

const RESET_FILTERS = `RESET_FILTERS_${NAME}`;

export const resetFilters = () => ({
	type: RESET_FILTERS,
});

const studentsFilterDefault = {
	curriculumProgramId: null,
	gradeIds: [],
	sectionIds: [],
	searchText: '',
	advancedFilters: [],
	shiftId: null,
	activeStatus: 'ACTIVE',
};

const staffFilterDefault = {
	curriculumProgramId: null,
	gradeIds: [],
	sectionIds: [],
	shiftId: null,
	searchText: '',
	activeStatus: 'ACTIVE',
};

const ACTION_MAP = {
	[SET_STUDENTS_FILTERS]: (state, action) => {
		const { campusId, filters } = action.payload;
		return {
			...state,
			studentsFilters: {
				...state.studentsFilters,
				[campusId]: {
					...studentsFilterDefault,
					...state.studentsFilters[campusId],
					...filters,
				},
			},
		};
	},
	[SET_STAFF_FILTERS]: (state, action) => {
		const { campusId, filters } = action.payload;
		return {
			...state,
			staffFilters: {
				...state.staffFilters,
				[campusId]: {
					...staffFilterDefault,
					...state.staffFilters[campusId],
					...filters,
				},
			},
		};
	},
	[RESET_FILTERS]: () => initialState,
};

const initialState = {
	studentsFilters: {},
	staffFilters: {},
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];
	return actionFunc ? actionFunc(state, action) : state;
};
